import { Trans, useTranslation } from "react-i18next";
import loginGraphic from "assets/images/login-graphic.svg";

const UACLoginRight = () => {
  const { t } = useTranslation();

  return (
    <div>
      <img src={loginGraphic} alt="" style={{ marginTop: 40, width: 270 }} />
      <p className="text-center">
        <Trans>{t("login.placeholder")}</Trans>
      </p>
    </div>
  );
};

export default UACLoginRight;
